import { Component, Input } from '@angular/core';
import { FormConfig } from '@ajgre/toolkit';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 're-label',
  imports: [],
  templateUrl: './label.component.html',
  styleUrl: './label.component.scss'
})
export class LabelComponent {
  @Input() formConfig!: FormConfig;
  @Input() disabled = false;

  hintId(): string {
    return `${this.formConfig.id}-hint`;
  }
}
